import axios from "axios";
import handleAreasState from './handleAreasState';
import mapResponseData from './mapResponseData';

const handleModifyGroupOfAreas = (
    id, 
    code, 
    area_id, 
    name, 
    state, 
    setPowerKW, 
    stopLoadingFunction, 
    areaArray, 
    setAreaArray
) => {

    const data = [
        {
          "area_id": area_id,
          "name": name,
          "mark": state
        }
    ];

    const areaToModify = areaArray.find(area => area.area_id === area_id);
    areaToModify.state = state;
    console.log("Area to modify: ", areaToModify);
    /*
    const newAreaArray = areaArray.map(area =>
        area.area_id === area_id ? { ...area, state } : area
    );*/

    const url = `https://api.lightpass.gradis.pl/api/requests/${id}/${code}/areas`;

    axios.put(
        url, data, {
            headers: {
                'Accept-Language': localStorage.getItem("language") || "pl"
            }
        }
    ).then((response) => {
        console.log("Modify group of areas response: ", response);
        setPowerKW([response.data.power_kw_min, response.data.power_kw_avg, response.data.power_kw_max]);
        const newAreaArray = mapResponseData(response);
        setAreaArray(newAreaArray);
        
        sessionStorage.setItem("powerKW", JSON.stringify([response.data.power_kw_min, response.data.power_kw_avg, response.data.power_kw_max]));
        stopLoadingFunction();
    }).catch((error) => {
        console.error("Error while modifying group of areas: ", error);
        //sessionStorage.setItem("powerKW", JSON.stringify([0, 0, 0]));
        //stopLoadingFunction();
    }).finally(() => {
        handleAreasState(areaArray);
    });
}

export default handleModifyGroupOfAreas;